import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'striphtml',
  standalone: false,
  pure: true
})
export class StripHtmlPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) {
      return '';
    }
    
    // Create a temporary div element to parse HTML
    const div = document.createElement('div');
    div.innerHTML = value;
    
    // Extract text content (removes all HTML tags)
    const text = div.textContent || div.innerText || '';
    
    // Trim and return
    return text.trim();
  }
}
